import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { SearchInputModule } from '../search-input/search-input.module';
import { ToTreeModule } from '../to-tree/to-tree.module';
import { DataPathPipe, HelpShellComponent } from './help-shell/help-shell.component';
import { HelpComponent } from './help.component';

@NgModule({
  declarations: [
    HelpShellComponent,
    HelpComponent,
    DataPathPipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    NzTableModule,
    SearchInputModule,
    NzTreeModule,
    ToTreeModule,
    NzModalModule,
    TranslateModule,
  ],
  exports: [
    HelpShellComponent,
    HelpComponent
  ]
})
export class HelpModule {
}
